import { DEALERS_API_URL } from 'constants/ApiConstants';
import type { MetaAction } from 'modules/global/generic.types';

import * as actionTypes from '../actionTypes/general';
import type {
  RemoveDocumentAction,
  ResetDocumentAction,
  UploadDocumentAction,
  UploadDocumentFailureAction,
  UploadDocumentPayload,
  UploadDocumentSuccessAction,
} from '../types';

export const resetDocuments = (meta: MetaAction = {}): ResetDocumentAction => ({
  type: actionTypes.RESET_DOCUMENTS,
  meta,
});

export const uploadDocument = (data: UploadDocumentPayload, meta: MetaAction = {}): UploadDocumentAction => ({
  type: actionTypes.UPLOAD_DOCUMENT,
  payload: {
    request: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/pdf',
      },
      url: `${DEALERS_API_URL}/configDocuments`,
    },
    ...data,
  },
  meta,
});

export const uploadDocumentSuccess = (payload: UploadDocumentSuccessAction['payload'], meta: MetaAction = {}): UploadDocumentSuccessAction => ({
  type: actionTypes.UPLOAD_DOCUMENT_SUCCESS,
  payload,
  meta,
});

export const uploadDocumentFailure = (
  payload: UploadDocumentFailureAction['payload'],
  meta: MetaAction = {}
): UploadDocumentFailureAction => ({
  type: actionTypes.UPLOAD_DOCUMENT_FAILURE,
  payload,
  error: true,
  meta,
});

export const removeDocument = (payload: RemoveDocumentAction['payload'], meta: MetaAction = {}): RemoveDocumentAction => ({
  type: actionTypes.REMOVE_DOCUMENT,
  payload,
  meta,
});
